import {
  type Type,
  Plugins,
  TypeImplementation,
  Result,
} from '@packages/systems/wfdl';
import {
  TTypeConstructor,
  TTypeApplication,
  TText,
  functionOf,
} from '@packages/systems/wfdl-ast';
import {
  pluginName,
  typeName,
  iconName,
  qualify,
} from '@packages/systems/wfdl-Qualified';
import {forall, a, call1, _$} from '@packages/utilities/wfdl-helpers';
import {LockIcon} from '@packages/systems/spring';

const tySecret = TTypeConstructor(
  qualify(pluginName('Secret'), typeName('Secret'))
);

export const TSecret = (arg: Type): Type =>
  TTypeApplication({
    con: tySecret,
    arg,
  });

export const TApiToken = TTypeConstructor(
  qualify(pluginName('Secret'), typeName('API token'))
);

export const TUserAndPass = TTypeConstructor(
  qualify(pluginName('Secret'), typeName('Username & password'))
);

export const TSecretApiToken = TSecret(TApiToken);
export const TSecretUserAndPass = TSecret(TUserAndPass);

export const unwrapSecret = call1(_$('Secret', 'Unwrap Secret'));

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    Secret: LockIcon,
  },
  dataTypes: {
    Secret: TypeImplementation.Custom({
      params: ['secret type'],
      parseValue: (_) =>
        Result.Error('Cannot use Literal expressions to create Secret values.'),
      render: () => null,
      icon: TypeImplementation.IconByName(
        qualify(pluginName('Secret'), iconName('Secret'))
      ),
      system: {bindUIVariant: 'custom'},
    }),
    'API token': TypeImplementation.Custom({
      parseValue: (_) =>
        Result.Error(
          'There cannot exist values of type “API token”. ' +
            'It is only used as a parameter for Secret.'
        ),
      render: () => null,
    }),
    'Username & password': TypeImplementation.Custom({
      parseValue: (_) =>
        Result.Error(
          'There cannot exist values of type “Username & password”. ' +
            'It is only used as a parameter for Secret.'
        ),
      render: () => null,
    }),
  },
  values: {
    'Unwrap Secret': {
      envType: {
        dataType: forall(['a'], functionOf(TSecret(a), TText)),
        exported: 'hidden',
      },
      // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
      value: (x) => x,
    },
  },
});
